module.exports = "<div class=\"svg-icons-wrp svg-icons-wrp_add\">\n        <svg class=\"svg-icons svg-icons_plus\"><use xlink:href=\"#icon-plus\" /> </svg>\n</div>\n{{localize 'CORE.FORM.EDITORS.REFERENCE.ADDNEW'}}";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/reference/templates/addNewButton.hbs
// module id = 674
// module chunks = 0